'use client';
import React from 'react';

import useFeature from '@/hooks/useFeature';

import { Ada } from '../Ada';
import { ZenDesk } from '../ZenDesk';

const ChatbotWidget = () => {
  const enableAda = Boolean(useFeature('retention-enable-ada'));

  return enableAda ? <Ada /> : <ZenDesk />;
};

export default React.memo(ChatbotWidget);
